<template>
	<div>
		<b-select
			v-model="dateRange"
			class="date-options gtm-date-range-selector"
			:class="{ 'with-picker': showPicker }"
			:size="size"
		>
			<option
				v-for="(option, index) in dateOptions"
				:key="index"
				:value="option.value"
			>
				{{ option.label }}
			</option>
		</b-select>
		<date-range-picker
			v-if="showPicker"
			:start="startDate"
			:end="endDate"
			:picker="picker"
			:size="size"
			@apply="setReportDate"
		/>
	</div>
</template>

<script>
import DateRangePicker from "./DateRangePicker";
import subDays from "date-fns/subDays";
import { date_server } from "@lab/utils/format";
import startOfMonth from "date-fns/startOfMonth";
import { select } from "buefy";
import { mapGetters, mapActions } from "vuex";

export default {
	components: {
		DateRangePicker
	},
	props: {
		showPicker: {
			type: Boolean,
			default: () => true
		},
		size: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {};
	},

	computed: {
		...mapGetters({
			reportDateRange: "reportQueries/dateRange",
			startDate: "reportQueries/startDate",
			endDate: "reportQueries/endDate",
			dateOptions: "reportFilters/dateOptions"
		}),
		dateRange: {
			get() {
				return this.reportDateRange;
			},
			set(range) {
				this.setDateRange(range);
			}
		},
		picker() {
			return this.dateRange === "custom";
		}
	},
	watch: {
		dateRange(value) {
			let date = new Date();
			if (value !== "custom") {
				date = subDays(date, value);
			} else {
				date = startOfMonth(date);
			}
			this.setStartDate(date_server(date));
			this.setEndDate(date_server(new Date()));
		}
	},
	mounted() {
		if (
			this.showPicker &&
			!this.dateOptions.find((o) => o.value === "custom")
		) {
			this.addDateOption({ label: "Custom range", value: "custom" });
		}
	},
	methods: {
		...mapActions({
			setDateRange: "reportQueries/setDateRange",
			setStartDate: "reportQueries/setStartDate",
			setEndDate: "reportQueries/setEndDate",
			setReportDate: "reportQueries/setReportDate",
			addDateOption: "reportFilters/addDateOption"
		})
	}
};
</script>

<style scoped>
.date-options.with-picker {
	margin-right: 1em;
}
</style>
